import { AdminConsentRequestPolicy } from '@microsoft/microsoft-graph-types-beta';
import { AdminConsentPolicySchema } from '../../../../../tools/schemas/graph/admin-consent-policy.schema';
import { updateAdminConsentRequestPolicy } from 'projects/angular-clarity/src/app/stores/client/graph/admin-consent-request-policy/actions';

export function Remediate(_tenant: string, policy: AdminConsentRequestPolicy, schema: AdminConsentPolicySchema) {
    return updateAdminConsentRequestPolicy({
        _tenant,
        data: {
            isEnabled: schema.properties.isEnabled.const,
            notifyReviewers: schema.properties.notifyReviewers?.const,
            remindersEnabled: schema.properties.remindersEnabled?.const,
            requestDurationInDays: schema.properties.requestDurationInDays?.const,
            reviewers: (schema.properties.reviewers?.allOf ?? [])
                .map((r) => {
                    const rawQuery = r.contains?.properties?.query?.pattern;

                    if (!rawQuery) return null;

                    let query = '';
                    if (rawQuery.startsWith('users/')) {
                        query = `/v1.0/${rawQuery}`;
                    } else if (rawQuery.startsWith('groups/')) {
                        query = `/v1.0/${rawQuery}/transitiveMembers/microsoft.graph.user`;
                    } else {
                        query = `/beta/roleManagement/directory/roleAssignments?$filter=roleDefinitionId eq '${rawQuery}'`;
                    }

                    return {
                        query,
                        queryType: 'MicrosoftGraph',
                    };
                })
                .filter((r) => r !== null),
        },
    });
}
